'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__($thiz, outer) {
  $thiz.s9 = outer;
  $thiz.vt = outer.dm.a.length;
  return $thiz;
}
export { $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__ as $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__ };
/** @constructor */
function $c_ju_HashMap$AbstractHashMapIterator() {
  this.vt = 0;
  this.m0 = 0;
  this.m1 = null;
  this.sa = null;
  this.s9 = null;
}
export { $c_ju_HashMap$AbstractHashMapIterator as $c_ju_HashMap$AbstractHashMapIterator };
$p = $c_ju_HashMap$AbstractHashMapIterator.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_ju_HashMap$AbstractHashMapIterator;
/** @constructor */
function $h_ju_HashMap$AbstractHashMapIterator() {
}
export { $h_ju_HashMap$AbstractHashMapIterator as $h_ju_HashMap$AbstractHashMapIterator };
$h_ju_HashMap$AbstractHashMapIterator.prototype = $p;
$p.i = (function() {
  if ((this.m1 !== null)) {
    return true;
  } else {
    while ((this.m0 < this.vt)) {
      var node = this.s9.dm.a[this.m0];
      this.m0 = ((1 + this.m0) | 0);
      if ((node !== null)) {
        this.m1 = node;
        return true;
      }
    }
    return false;
  }
});
$p.e = (function() {
  if ((!this.i())) {
    throw $j_java$002elang$002e$002dObject.$ct_ju_NoSuchElementException__T__(new $j_java$002elang$002e$002dObject.$c_ju_NoSuchElementException(), "next on empty iterator");
  }
  var node = this.m1;
  this.sa = node;
  this.m1 = node.fw;
  return this.OW(node);
});
$p.rg = (function() {
  var last = this.sa;
  if ((last === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalStateException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalStateException(), "next must be called at least once before remove");
  }
  this.s9.WW(last);
  this.sa = null;
});
